import BaseModelAPI from '../BaseModelAPI';

export default class AttachmentPartPurchaseQualityControl extends BaseModelAPI {
	static entity = 'attachmentpartpurchasequalitycontrol';
	static entityName = 'attachmentpartpurchasequalitycontrol';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.partPurchaseQcDetailId = '';
			this.partPurchaseQcDetail = {};
			this.evidenceId = '';
			this.evidence = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}